import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  title: string
}

export const BlackListWarning = ({ title }: Props) => {
  return (
    <div className={s.container}>
      <AppIcon
        id={AllIcons.DANGER}
        width={16}
        height={16}
      />
      <p className={clsx('medium-12', s.text)}>{title}</p>
    </div>
  )
}
